module.exports = __webpack_public_path__ + "static/media/17390749_10154599579368990_8087930299916960951_o.83d28917.jpg";